<template></template>
<script>
  export default {
    name: 'WebGLDetect',
    methods: {
      detectWebGL: function () {
        const renderingContext = !!window.WebGLRenderingContext
        if (renderingContext) {
          let canvas = document.createElement('canvas')
          let names = ['webgl', 'experimental-webgl', 'moz-webgl', 'webkit-3d']
          let context = false

          for (let i in names) {
            try {
              context = canvas.getContext(names[i])
              if (context && typeof context.getParameter === 'function') {
                // WebGL is enabled.
                return 1
              }
            } catch (e) {}
          }

          // WebGL is supported, but disabled.
          return 0
        }

        // WebGL not supported.
        return -1
      }
    },
    created () {
      this.$store.commit('SET_WEBGL_STATUS', this.detectWebGL())
    }
  }
</script>



// WEBPACK FOOTER //
// WebGLDetect.vue?37041134